module.exports = __webpack_public_path__ + "static/media/notification.c0d3c94c.eot";